import { render, staticRenderFns } from "./VenueList.vue?vue&type=template&id=0cb57bd2&"
import script from "./VenueList.vue?vue&type=script&lang=js&"
export * from "./VenueList.vue?vue&type=script&lang=js&"
import style0 from "./VenueList.vue?vue&type=style&index=0&id=0cb57bd2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports